import { capitalize } from "lodash";

import { NOT_AVAILABLE, OTHER_REASON } from "./constants";
import { PlanType, ProductType, Quote } from "./types";

export const formatDate = (date: string, isUTC = false) =>
  date &&
  new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    ...(isUTC && { timeZone: "UTC" }),
  });

export const getProposalReceivedDateFormatted = (
  quotes: Quote[],
  isUTC = false,
) => {
  const receivedDate = quotes?.find((quote) => quote.proposal?.receivedDate)
    ?.proposal?.receivedDate;
  return receivedDate ? formatDate(receivedDate, isUTC) : "-";
};

export const getProductDisplayName = (
  productType: ProductType | null,
  productPlanType?: PlanType | null,
): string => {
  if (!productType) {
    return NOT_AVAILABLE;
  }

  const productDisplayMap = {
    std: "STD",
    ltd: "LTD",
    basicLife: "Basic Life",
    voluntaryLife: "Voluntary Life",
    criticalIllness: "Critical Illness",
    hospitalIndemnity: "Hospital Indemnity",
  };

  if (productType === "dental" && productPlanType) {
    return `${capitalize(productType)} ${productPlanType?.toUpperCase()}`;
  }

  const displayValue =
    productDisplayMap[productType as keyof typeof productDisplayMap];
  if (displayValue) {
    return displayValue;
  }

  return capitalize(productType);
};

export const getOtherReasonParts = (
  reasons: Record<string, string>,
  value: string | null,
): { reason: string; otherReason: string } => {
  let reason = "";
  let otherReason = "";
  if (value) {
    if (reasons[value]) {
      reason = value;
    } else {
      reason = OTHER_REASON;
      otherReason = value;
    }
  }
  return { reason, otherReason };
};
